import { report } from "process";

export const routes = {
  all: "*",
  homePage: "/",
  dashboard: "/dashboard",
  profile: "/profile",
  staff: "/staff",
  reports: "/reports",
  promotionCoupons: "/promotions-coupons",
  addStaff: "/staff/add-staff",
  editStaff: "/staff/edit-staff/:id",
  viewStaff: "/staff/view-staff/:id",
  addcoupons: "/promotions-coupons/add-coupons",
  editcoupons: "/promotions-coupons/edit-coupons/:id",
  addStaff: "/staff/add-staff",
  editStaff: "/staff/edit-staff/:id",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyOtp: "/verify-otp",
  verifyauth: "/varify-auth",
  setUpAuth: "/set-up-authentication",
  tenants: "/tenants",
  addTenants: "/tenants/add-tenant",
  editTenants: "/tenants/edit-tenant/:id",
  viewTenants: "/tenants/view-tenant/:id",
  plan: "/plans",
  editPlan: "/plans/edit-plan/:id",
  tenantDetails: "tenants/tenant-details",
  acmeCoOperation: "tenants/acme-co-operation/:id",
  subscriptionBillingPage: "/subscription-billing/",
  analyticsReport: "/analytics-reports/",
  adminControls: "/admin-controls/",
  tenantAddedSuccess: "/tenant/tenant=added-successfully",
  freeTrialManagement: "/free-trial-management",
  provisionTenants: "/provision-tenants",
  editProvisionTenants: "/provisionTenants/:id",
  discountManagement: "/discount-management",
  setting: "/setting",
  feedbackTriage: "/feedback-triage",
  security: "/security",
  help: "/help",
  importCsv: "/import-csv",
};

export const apiEndPoints = {
  signIn: "/admin/admin-login",
  getTenants: "/admin/tenant-list",
  addTenant: "/admin/add-tenant",
  getPlans: "/public/get-plan",
  getTenantDetails: "/admin/tenant-info",
  editTenant: "/admin/edit-tenant",
  editPlan: "/admin/edit-plan",
  getPlanDetails: "/public/plan-info",
  editStatusTenant: "/admin/action-tenant",
  getDashboardData: "/admin/dashboard",
  togglePlanManagement: "/admin/toggle-settings",
  getSettingDetails: "/admin/get-settings",
  resendInvite: "/admin/resend-token",
  getPlanFeature: "/admin/features",
  accessAccount: "/admin/request-access",
  getTempToken: "/admin/verify-admin-access",
  getStaffs: "/admin/staff",
  addStaff: "/admin/staff",
  updateStaff: "/admin/staff",
  getStaffDetails: "/admin/staff",
  deleteStaff: "/admin/staff",
  assignStaff: "/admin/staff/assign", //
  getCouponList: "/admin/promotion",
  addCoupon: "/admin/promotion",
  updateCoupon: "/admin/promotion",
  getCouponDetails: "/admin/promotion",
  deleteCoupon: "/admin/promotion",
  getModules: "/public/get-modules",
  settings: "/admin/settings",
  countries: "/public/countries",
  forgotPassword: "/admin/forgot-password",
  verifyOtp: "/admin/forgot-password/verify-otp",
  resetPassword: "/admin/reset-password",
  twofaSetup: "/admin/twofa/setup",
  twofaVerify: "/admin/twofa/verify",
  profileData: "/user/get-profile",
  twofaToggle: "/admin/twofa/toggle",
  forgotTwofaAuthVerify: "/twofa/send-otp-reset", //
  twofaAuthVerifyOtp: "/twofa/verify-otp", //
  discount: "/public/get-discount-variables",
  createProgram: "/admin/discount/program",
  programList: "/admin/discount/program",
  codeList: "/admin/discount/code",
  // feedbackType: "/feedback/types",
  // feedbackStatus: "/feedback/status",
  createCode: "/admin/discount/code",
  applicationList: "/admin/discount/application",
  exportDiscount: "/admin/discount/export",
  getCommunicationlist: "/admin/communication",
  discountUsage: "/admin/discount/discount-usage",
  discountUsageList: "/admin/discount/application-export",
  analytics: "/admin/discount/analysis",
  importCode: "/admin/discount/import-code",
  feedbackType: "/feedback/types",
  feedbackStatus: "/feedback/status",
  createFeedback: "/feedback",
  getAllFeedback: "/feedback",
  getFeedbackById: "/feedback",
  updateFeedback: "/feedback",
  adminUpdateFeedback: "/feedback",
  deleteFeedback: "/feedback",
  addVote: "/feedback/vote",
  addComment: "/feedback/comment",
  updateComment: "/feedback/comment",
  deleteComment: "/feedback/comment",
  roadmap: "/feedback/roadmap",
  dashboard: "/feedback/dashboard",
  feedbackAnalytics: "/feedback/analytics",
  dashboardDetails: "/admin/dashboard",
  updateProfile: "/user/set-profile",
};
